import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: '../../../assets/html/home.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    /*$('[data-parallax="scroll"]').each(function () {
      var $this = $(this);
      $this.parallax({ dataImageSrc: $this.data('image-src') });
    });
    let options = {
      strings: ["klein", "promo", "nieuw"],
      typeSpeed: 100,
      backSpeed: 100,
      showCursor: true,
      cursorChar: "|",
      loop: true
    }

    let typed = new Typed("#typed", options);    */

    $(".carousel-default").owlCarousel({
   	 navigation : true,
   	 slideSpeed : 300,
   	 paginationSpeed : 400,
   	 autoPlay : true,
     addClassActive: true,
     navigationText: ["&#xf007","&#xf006"],
   	 singleItem:true
  });

  // Owl Carousel - Content Blocks
  $(".carousel-blocks").owlCarousel({
     slideSpeed: 300,
     autoPlay: false,
     navigation: true,
     navigationText: ["&#xf007","&#xf006"],
     pagination: false,
     addClassActive: true,
     items: 5,
     itemsDesktop: [768,3],
     itemsDesktopSmall: [480,1]
  });

  $(".carousel-fade-transition").owlCarousel({
   	 navigation : true,
   	 slideSpeed : 300,
   	 paginationSpeed : 400,
   	 autoPlay : true,
     addClassActive: true,
     navigationText: ["&#xf007","&#xf006"],
   	 singleItem:true,
     transitionStyle : "fade"
  });
  }

}

